function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* eslint-disable no-underscore-dangle */

/* global window */


import React from "react";
import VKContext from "./VKContext";
import VKApi from "./API";
var VKInstance = null;

var VK =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(VK, _React$Component);

  function VK() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_mounted", true);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      vk: null
    });

    return _this;
  }

  var _proto = VK.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var onApiAvailable = this.props.onApiAvailable;

    if (typeof window !== "undefined" && window.document && window.document.createElement) {
      this.VKinit().then(function (vk) {
        onApiAvailable(vk);
        if (_this2._mounted) _this2.setState({
          vk: vk
        });
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._mounted = false;
  };

  _proto.VKinit = function VKinit() {
    var _this$props = this.props,
        apiId = _this$props.apiId,
        options = _this$props.options;

    if (!this.vk) {
      this.vk = VKInstance || new VKApi(apiId, options);
      VKInstance = this.vk;
    }

    return this.vk.init();
  };

  _proto.render = function render() {
    var vk = this.state.vk;
    var children = this.props.children;
    return vk ? React.createElement(VKContext.Provider, {
      value: vk
    }, children) : null;
  };

  return VK;
}(React.Component);

_defineProperty(VK, "defaultProps", {
  options: {
    version: 159,
    onlyWidgets: true
  },
  onApiAvailable: function onApiAvailable() {}
});

export { VK as default };